import { TrSpace } from "../components/TrSpace";
import { FormPageButton } from "../components/FormPageButton";
import { TrText } from "../components/TrText";
import { TrTextField } from "../components/TrTextField";
import { TrTextArea } from "../components/TrTextArea";
import { useDispatch } from "react-redux";
import { registerInquiry } from "../reducks/inquiry/operations";
import { useCallback, useState } from "react";

export const Inquiry = () => {
    const dispatch = useDispatch();

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [content, setContent] = useState("");
    const [isAlertForName, setIsAlertForName] = useState(false)
    const [isAlertForEmail, setIsAlertForEmail] = useState(false)
    const [isAlertForContent, setIsAlertForContent] = useState(false)

    const inputName = useCallback((event) => {
        setName(event.target.value);
    }, [setName]);

    const inputEmail = useCallback((event) => {
        setEmail(event.target.value);
    }, [setEmail]);

    const inputContent = useCallback((event) => {
        setContent(event.target.value);
    }, [setContent]);

    function checkValidate() {
        if(name === "") {
            setIsAlertForName(true);
        }else{
            setIsAlertForName(false); 
        }
        
        if(email === "") {
            setIsAlertForEmail(true);
        }else{
            setIsAlertForEmail(false);
        }

        if (content === "") {
            setIsAlertForContent(true);
        } else {
            setIsAlertForContent(false);
        }

    }

    return (
        <div className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>お問い合わせ</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table className="iPad/iPadMini:w-11/12 md:w-6/12">
                            <tbody>
                                <TrText text="お名前"/>
                                <TrTextField id="inquiry-name" placeholder="お名前（必須）" required={true} isAlert={isAlertForName} onChange={inputName}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="メールアドレス"/>
                                <TrTextField id="inquiry-mail" placeholder="メールアドレス（必須）" required={true} isAlert={isAlertForEmail} onChange={inputEmail}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="お問い合わせ"/>
                                <TrTextArea id="inquiry-textarea" placeholder="お問い合わせ（必須）" isAlert={isAlertForContent} onChange={inputContent}/>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                        <FormPageButton 
                            text="問い合わせる"
                            onClick={() => {
                                checkValidate();
                                dispatch(registerInquiry(name, email, content));
                            }}
                        />
                    </div>
                </main>
        </div>
    );
};